<template>
  <div>
    <b-card header="Vista Ampliada de la Imagen">
      <b-img center fluid :src="url"></b-img>
      <div slot="footer">
        <b-button size="sm" variant="danger" class="footer-button" 
          @click.prevent="close">Cerrar</b-button>
      </div>
    </b-card>
  </div>
</template>

<script>

export default {
  name: 'Imagen',
  props: {
    url: {
      type: String,
      default: '',
    }
  },
  data () {
    return {
    }
  },
  created() {
  },  
  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>

<style>
</style>
